<template>
  <va-modal
    v-model="internalShowModal"
    ok-text="Aceitar"
    cancel-text="Não"
    blur
    no-dismiss
    max-height="600px"
    @ok="onConfirm"
    @cancel="onCancel"
  >
    <h3 class="va-h5">TERMOS E CONDIÇÕES DE USO DA PLATAFORMA MULTIMARCAS.ONLINE</h3>

    <p class="va-text-justify">
      Este instrumento contempla os Termos e Condições de Uso da plataforma de gestão empresarial Multimarcas.online.
      Antes de acessar e usar a Plataforma, certifique-se de que compreendeu todas as condições estabelecidas neste
      instrumento. Eventuais dúvidas deverão ser sanadas em contato prévio com a equipe do Multimarcas.online, por meio
      dos canais de atendimento do Multimarcas.online (e-mail, telefone, chat e/ou ticket). Após ler, compreender e
      concordar com todo o conteúdo deste Termos e Condições de Uso, você poderá aderir a ele. Caso você não concorde
      com este Termos e Condições de Uso, você deverá imediatamente suspender o uso da Plataforma. Você somente poderá
      utilizar a Plataforma caso aceite integralmente os Termos e Condições de Uso. A utilização da Plataforma implica a
      aceitação plena, irrestrita e sem reservas de todos os termos e condições previstos neste documento, inclusive no
      caso de eventuais revisões ou publicação de novas versões. No caso de revisões ou publicações de novas versões,
      você será avisado previamente e, caso não concorde com as alterações, deverá descontinuar o uso da Plataforma. O
      uso continuado da Plataforma, após a revisão dos Termos e Condições de Uso, implica aceitação das alterações, sem
      ressalvas.
    </p>

    <br />

    <p class="va-text-justify">
      1. DEFINIÇÕES <br /><br />
      1.1. Definições. Os termos iniciados em letra maiúscula indicados a seguir serão utilizados neste instrumento com
      o significado detalhado abaixo: <br /><br />

      a. “Multimarcas.online”: é a Wecast Solucoes em Tecnologia e Gestao Digital, inscrita no CNPJ sob o n.º
      04.124.535/0001-25, com sede na Rua Luiz Michielon, 1212 CEP 95074-000, Bairro Cruzeiro, no Município de Caxias do
      Sul, Estado do Rio Grande do Sul. <br /><br />

      b. “Planos”: são os diferentes tipos de planos oferecidos pelo Multimarcas.online para uso da Plataforma. Os
      Planos darão acesso a funcionalidades da Plataforma na medida especificada pela descrição do plano escolhido no
      momento da contratação. Os Planos terão valores distintos a depender das funcionalidades desejadas e da quantidade
      de informações armazenadas nos servidores do Multimarcas.online. Todos os Planos, independentemente do valor e das
      funcionalidades contratadas, estão sujeitos a estes Termos de Uso, inclusive os Planos oferecidos eventualmente de
      forma gratuita ou com desconto. <br /><br />

      c. “Plataforma”: é a ferramenta de gestão empresarial constituída por uma aplicação de web software de
      responsabilidade, propriedade e operação do Multimarcas.online. A Plataforma tem por finalidade auxiliar os
      Usuários a realizar tarefas da rotina empresarial, incluindo, mas não se limitando a: (i) emissão de notas
      fiscais; (ii) controle de caixa; (iii) controle de estoque; (iv) manutenção de cadastros de clientes, fornecedores
      e produtos; (iv) controle de vendas; (v) controle de finanças; e (vi) integração com lojas virtuais, marketplaces
      e outras aplicações. <br /><br />

      d. “Política de Privacidade”: é o conjunto de regras que disciplina a coleta e a utilização de dados pessoais dos
      Usuários e de suas contrapartes. <br /><br />

      e. Termos de Uso: é este instrumento, que disciplina os termos e as condições gerais que regerão o acesso e o uso
      da Plataforma pelos Usuários. O Multimarcas.online poderá estabelecer Termos de Uso específicos e aplicáveis a
      determinados produtos ou funcionalidades, conforme o caso, que complementarão e prevalecerão sobre este Termos de
      Uso. <br /><br />

      f. “Usuário”: são os clientes do Multimarcas.online cadastrados na Plataforma, que podem ser tanto pessoas físicas
      como jurídicas, pagantes ou não. Os clientes são identificados no momento de preenchimento do formulário para
      acesso e uso da Plataforma.
    </p>

    <br />

    <p class="va-text-justify">
      2. OBJETO <br /><br />
      2.1. Objeto. Este Termos de Uso tem por objeto disciplinar os termos e as condições gerais que regerão o acesso e
      o uso da Plataforma pelos Usuários.
    </p>

    <br />

    <p class="va-text-justify">
      3. CADASTRO DE USUÁRIOS <br /><br />
      3.1. Informações cadastrais. Para utilizar as funcionalidades disponibilizadas pela Plataforma, o Usuário deve
      fornecer informações específicas a respeito de si e/ou da pessoa física ou jurídica que representa. Ao aderir a
      este Termos de Uso, o Usuário declara e garante que forneceu e sempre fornecerá ao Multimarcas.online informações
      exatas, atualizadas e verdadeiras. O Usuário declara-se ciente de que a utilização de dados falsos,
      desatualizados, inválidos, incorretos ou de terceiros poderá acarretar o término antecipado da vigência deste
      Termos de Uso, com o consequente impedimento da utilização, pelo Usuário, da Plataforma, sem prejuízo de
      responsabilização civil e criminal do Usuário, bem como do pagamento de indenização por perdas e danos sofridos
      pelo Multimarcas.online. <br /><br />

      3.1.1. Atualização de informações cadastrais. O Usuário obriga-se a manter atualizadas todas as informações
      cadastrais a seu respeito, devendo atender prontamente quaisquer solicitações referentes à atualização cadastral,
      sob pena de suspensão ou cancelamento de seu cadastro, sem que tal suspensão ou cancelamento gere ao Usuário
      qualquer direito de indenização ou reembolso. <br /><br />

      3.1.2. Bloqueio do acesso por inconsistência em informações cadastrais. O Usuário reconhece e aceita que nas
      hipóteses de (a) o Multimarcas.online constatar a existência de informações cadastrais incorretas, inverídicas,
      desatualizadas ou inexatas, e/ou de (b) o Usuário não disponibilizar informações e/ou documentos eventualmente
      requeridos pelo Multimarcas.online, o Multimarcas.online poderá, a seu critério exclusivo e discricionário,
      bloquear por tempo indeterminado o cadastro do Usuário. Em decorrência do bloqueio cadastral, o Usuário estará
      temporariamente impedido de acessar e utilizar as funcionalidades da Plataforma, sem que nenhuma responsabilidade
      possa ser imputada ao Multimarcas.online. <br /><br />

      3.2. Ausência de impedimentos para adesão a este Termos de Uso. Ao aderir a este Termos de Uso, o Usuário declara
      não ter nenhum impedimento para efetuar seu cadastro e acessar a Plataforma, inexistindo contrato ou vínculo de
      qualquer natureza com terceiros ou qualquer decisão ou restrição imposta por uma autoridade governamental ou
      judiciária que de qualquer forma o impeça de aderir a este Termos de Uso. O Usuário declara possuir capacidade
      jurídica para contratação da Plataforma, bem como se obriga pelo pagamento da mensalidade atribuída à pessoa
      física ou jurídica em nome da qual ocorreu a contratação. Caso o Usuário venha a realizar contratação em nome de
      pessoa física ou jurídica para a qual não possua capacidade de representação, o Usuário estará pessoalmente
      responsável às obrigações deste instrumento, incluindo o pagamento dos serviços. <br /><br />

      3.3. Sigilo das credenciais de acesso à Plataforma. O Usuário é responsável por manter em sigilo as credenciais de
      acesso à Plataforma (nome de usuário, senha, entre outros), assumindo a responsabilidade de não compartilhar com
      terceiros as suas informações de acesso. Caso o acesso à Plataforma seja efetuado por terceiros em razão da
      negligência do Usuário em relação aos seus dados de acesso à Plataforma, o Multimarcas.online fica isento de
      qualquer responsabilidade relacionada à privacidade e segurança das informações e arquivos do Usuário. O Usuário
      não poderá compartilhar, dividir ou fornecer suas credenciais de acesso para utilização de terceiros, sob pena de
      cancelamento da conta e término da relação contratual com o Multimarcas.online, além da eliminação de todas as
      informações e arquivos armazenados na Plataforma. O Usuário é obrigado a comunicar ao Multimarcas.online a
      respeito de eventual extravio ou alienação das informações de acesso à conta (nome de usuário, senha, entre
      outros), observado que o Multimarcas.online não se responsabiliza pela segurança e privacidade das informações do
      Usuário em caso de uso ou compartilhamento negligente ou imprudente das informações de acesso. <br /><br />

      3.3.1. Responsabilidade por perfis criados pelo Usuário para uso da Plataforma. O Usuário poderá criar diferentes
      perfis na Plataforma para que seus colaboradores possam usar a Plataforma, tendo os perfis acesso a diferentes
      funcionalidades a depender das configurações escolhidas pelo Usuário. O Usuário será o único e exclusivo
      responsável por toda a atividade realizada na Plataforma por meio da utilização dos perfis que criou, devendo
      informar, orientar e fazer com que seus colaboradores observem todas as regras previstas neste Termos de Uso,
      particularmente as regras de sigilo sobre as credenciais de acesso à Plataforma (nome de usuário, senha, entre
      outros). <br /><br />

      3.4. Comunicação com o Usuário. O Usuário declara que o e-mail, telefone e endereço físico informados ao
      Multimarcas.online por meio da Plataforma são meios igualmente eficazes, válidos e suficientes para recebimento de
      comunicados relacionados à sua conta, bem como para informações de cancelamento ou suspensão de uso da Plataforma.
      O Usuário reconhece e autoriza também a utilização da página inicial de acesso à Plataforma como meio eficaz,
      válido e suficiente para a divulgação de assuntos relacionados ao Plano contratado, inclusive em relação a
      eventual reajuste de preços ou alteração de funcionalidades e dos limites de armazenamento.
    </p>

    <br />

    <p class="va-text-justify">
      4. USO DA PLATAFORMA <br /><br />

      4.1. Uso da Plataforma em conformidade com o Plano contratado. Ao contratar um dos Planos oferecidos pelo
      Multimarcas.online e aderir a este Termos de Uso, o Usuário terá acesso às funcionalidades da Plataforma conforme
      os termos e as condições do Plano contratado. Este Termos de Uso também será aplicado aos Usuários que optaram por
      utilizar Planos gratuitos eventualmente oferecidos pelo Multimarcas.online. Os Planos gratuitos podem ser
      suspensos ou cancelados pelo Multimarcas.online a qualquer tempo, sem a necessidade de prévia comunicação ao
      Usuário. <br /><br />

      4.1.1. Dúvidas e questões sobre o Plano contratado. A escolha por um dos Planos oferecidos pelo Multimarcas.online
      é parte integrante do procedimento de contratação da Plataforma, estando o Usuário vinculado ao Plano escolhido no
      momento da contratação. O Usuário declara e garante que os espaços de armazenamento e as funcionalidades da
      Plataforma estão claramente descritas e informadas no portal eletrônico do Multimarcas.online, não podendo o
      Usuário demandar o Multimarcas.online por funcionalidades ou armazenamento não incluídos no Plano contratado. Caso
      o Usuário tenha alguma dúvida em relação ao Plano anunciado, deverá contatar um representante do
      Multimarcas.online através dos canais de atendimento oficiais do Multimarcas.online (e-mail, telefone, chat e
      ticket) antes de confirmar a contratação e a sua adesão a este Termos de Uso. <br /><br />

      4.2. Alteração do Plano contratado. Durante o período em que o Usuário estiver utilizando a Plataforma, o Usuário
      poderá optar por migrar para outro Plano oferecido pelo Multimarcas.online. Neste caso, os valores serão alterados
      e cobrados de acordo com o respectivo novo Plano aderido, de maneira proporcional ao período utilizado e passando
      a incidir o valor integral da nova mensalidade a partir do mês seguinte ao mês em que a opção pela alteração de
      Plano for formalizada. <br /><br />

      4.3. Condutas proibidas na utilização da Plataforma. O Usuário se obriga a utilizar a Plataforma de boa-fé e sem a
      intenção de praticar atos ilícitos ou causar danos a terceiros. Sem prejuízo ou limitação às demais obrigações e
      restrições previstas neste Termos de Uso e na legislação pertinente, o Usuário obriga-se a não praticar e a fazer
      com que quaisquer pessoas autorizadas que tenham acesso à Plataforma não pratiquem nenhuma das seguintes condutas:
      <br /><br />

      (a) distribuir, reproduzir, modificar, vender, alugar ou de qualquer forma explorar economicamente a Plataforma,
      seus dados, informações, código-fonte, marcas, direitos autorais relacionados, ou qualquer outro conteúdo
      veiculado pelo Multimarcas.online, exceto se com a autorização prévia e por escrito do Multimarcas.online;
      <br /><br />

      (b) realizar quaisquer modificações, melhoramentos, adaptações, obras derivadas ou traduções da Plataforma;
      <br /><br />

      (c) decifrar, decodificar, desmontar, realizar engenharia reversa, ou tentar deduzir qualquer parte do
      código-fonte, ideia subjacente ou algoritmos relacionados à Plataforma; <br /><br />

      (d) investigar ou testar a vulnerabilidade de qualquer sistema ou rede relacionada à Plataforma; <br /><br />

      (e) acessar, adulterar ou usar áreas não públicas da Plataforma ou quaisquer áreas compartilhadas para as quais o
      Usuário não possui autorização de acesso; <br /><br />

      (f) causar danos, interferir ou perturbar outros Usuários e/ou servidores de hospedagem ou rede; <br /><br />

      (g) corromper, danificar, limitar ou interferir na função apropriada e normal de softwares, hardwares, ferramentas
      ou equipamentos relacionados à Plataforma; <br /><br />

      (h) obter acesso não autorizado a sistemas, informações, senhas, ou outros dados do Multimarcas.online e/ou de
      quaisquer Usuários ou terceiros; <br /><br />

      (i) interferir no funcionamento normal da Plataforma, incluindo por meio de envio ou transmissão de qualquer
      arquivo malicioso que contenha vírus, worms, cavalos de Tróia ou qualquer outra espécie de programação ou comando
      que possa contaminar, destruir ou interferir no bom funcionamento da Plataforma; <br /><br />

      (j) violar ou contornar medidas de segurança e/ou autenticação do Multimarcas.online para restringir ou prevenir o
      acesso a ferramentas, contas, sistemas e redes relacionadas à Plataforma; e <br /><br />

      (k) utilizar os serviços contratados para fins de infração à legislação brasileira, para fins de causar danos a
      terceiros ou para fins de armazenar documentos que estejam relacionados a ilícitos cíveis ou penais. <br /><br />

      4.4. Acesso à Plataforma. A Plataforma é disponibilizada através da rede mundial de computadores, sendo de inteira
      responsabilidade do Usuário o dispositivo pelo qual realiza o acesso, bem como sua conexão própria com a internet,
      englobando, provedor de acesso, modem, e demais intermediários envolvidos na conexão particular do Usuário. O
      Multimarcas.online não possui qualquer obrigação sobre os dispositivos e conexões particulares do Usuário. O
      Usuário assume a obrigação de não acessar a Plataforma através de conexão indireta aos servidores do
      Multimarcas.online, não podendo fazer uso de tecnologias de proxy ou virtual private network (VPN) ou qualquer
      outra tecnologia que impeça o completo conhecimento por parte do Multimarcas.online do número de IP (Internet
      Protocol) utilizado na conexão, ou que mostre número de IP diferente do computador de origem do acesso, sob pena
      de cancelamento do Plano contratado por violação às regras de segurança dos servidores do Multimarcas.online. O
      Usuário é responsável por realizar o acesso à Plataforma apenas em computadores seguros e privados, que estejam
      livres de vírus e que sejam confiáveis do ponto de vista de segurança dos dados inseridos, não havendo
      responsabilidade do Multimarcas.online por qualquer forma de indenização em razão de acesso em computadores
      públicos, como, por exemplo, em lan houses.
    </p>

    <br />

    <p class="va-text-justify">
      5. DISPONIBILIDADE E MANUTENÇÃO DA PLATAFORMA <br /><br />
      5.1. Tempo de disponibilidade da Plataforma. O Multimarcas.online envidará os seus melhores esforços para que a
      Plataforma opere continuamente, assumindo a obrigação de manter o sistema disponível no regime de 24x7x365 (24
      horas por dia, 7 dias por semana, 365 dias por ano) por no mínimo 98% (noventa e oito por cento) do tempo de
      operação de cada mês. <br /><br />

      5.1.1. Interrupções que não afetam o tempo de disponibilidade da Plataforma. Os períodos de funcionamento afetados
      por manutenções programadas, manutenções preventivas, falta de energia elétrica, interrupção ou suspensão da
      prestação dos serviços de telecomunicações, ocorrências de falhas no sistema de transmissão ou roteamento no
      acesso à internet, atualizações do sistema, ou casos fortuitos e de força maior, estarão excluídos do tempo de
      operação e não configurarão qualquer tipo de responsabilidade ou obrigação de indenizar para Multimarcas.online.
      Em caso de manutenções urgentes, o Multimarcas.online envidará seus melhores esforços para comunicar os Usuários a
      respeito da possível suspensão ou interrupção dos serviços com antecedência razoável para não prejudicar as
      atividades do Usuário. <br /><br />

      5.1.2. Desconto na mensalidade em caso de violação do tempo de disponibilidade da Plataforma. Exceto nas hipóteses
      previstas em 5.1.1, caso o Multimarcas.online não consiga garantir que a Plataforma esteja disponível por no
      mínimo 98% (noventa e oito por cento) do tempo de operação em um determinado mês, o Usuário fará jus a um desconto
      em sua mensalidade proporcional ao tempo em que a Plataforma tiver ficado indisponível acima do limite previsto
      acima. <br /><br />

      5.2. Assistência técnica. O Multimarcas.online oferecerá aos Usuários assistência técnica relacionada a falhas e
      defeitos do funcionamento da Plataforma, mas não será responsável pela operação individual dos dispositivos do
      Usuário. O Multimarcas.online utilizará os seus melhores esforços para responder os chamados abertos pelos
      Usuários a respeito de problemas ou falhas técnicas da Plataforma no prazo de até 72 (setenta e duas) horas,
      momento no qual o Multimarcas.online informará o prazo final para resolução do problema ou falha técnica apontado
      pelo Usuário. <br /><br />

      5.2.1. Horário de atendimento. O horário de atendimento telefônico disponibilizado pelo Multimarcas.online é de
      segunda a sexta-feira das 8:20 às 17:45. Qualquer chamada realizada fora dos dias e horários informados não será
      atendida. <br /><br />

      5.2.2. Custos com ligações telefônicas. O Multimarcas.online não oferecerá ao Usuário assistência técnica através
      de número “0800” ou qualquer outra modalidade de ligação gratuita. As linhas de telefone colocadas à disposição
      para fins de assistência técnica estarão localizadas em DDD do Rio Grande do Sul, razão pela qual as chamadas
      realizadas pelo Usuário poderão ser cobradas por sua operadora, a depender de tarifas próprias e contratadas. O
      Multimarcas.online não é responsável pelo pagamento ou ressarcimento de valores gastos com ligações locais ou
      interurbanas destinadas à central de assistência, sendo os custos com a chamada telefônica de total e inteira
      responsabilidade do Usuário. <br /><br />

      5.3. Suspensão de uso da Plataforma. O Multimarcas.online se reserva o direito de suspender o acesso do Usuário à
      Plataforma sem notificação prévia caso seja verificado mau uso, causado por volume muito acima de médias ou
      operações consideradas inapropriadas para o bom uso e segurança da Plataforma. <br /><br />

      5.4. Descontinuidade da Plataforma. O Multimarcas.online poderá suspender, interromper ou descontinuar a
      Plataforma, a qualquer tempo, a seu critério e conforme lhe convier, ainda que fora das hipóteses previstas neste
      Termos de Uso, mediante aviso prévio com prazo razoável aos Usuários, sem que isso configure nenhum tipo de
      responsabilidade para o Multimarcas.online.
    </p>

    <br />

    <p class="va-text-justify">
      6. PROPRIEDADE INTELECTUAL <br /><br />
      6.1. Ausência de transferência de direitos de propriedade intelectual. O Usuário reconhece e aceita que este
      Termos de Uso e a utilização da Plataforma não lhe conferem nenhum direito, incluindo, mas não se limitando a
      direitos autorais e/ou direitos de propriedade industrial sobre a Plataforma e/ou qualquer funcionalidade ou
      serviço disponibilizado por meio da Plataforma, bem como sobre todos e quaisquer materiais e conteúdos de qualquer
      natureza que digam respeito e/ou estejam relacionados à Plataforma ou ao Multimarcas.online e seus parceiros
      comerciais e subcontratados, incluindo marcas, sinais distintivos, logotipos, imagens, sons, fotografias,
      documentos, textos ou quaisquer outros elementos disponibilizados na Plataforma. O Usuário reconhece e aceita
      ainda que está proibido de fazer uso ou de permitir que terceiros façam uso de tais materiais, conteúdos e de
      quaisquer direitos autorais e/ou direitos de propriedade industrial de titularidade do Multimarcas.online ou de
      qualquer terceiro que tenha licenciado tais direitos ao Multimarcas.online, sem prévia e expressa autorização do
      respectivo titular. Por consequência, o Usuário declara-se ciente de que o uso indevido e a reprodução total ou
      parcial dos referidos conteúdos e ferramentas são proibidos, salvo mediante autorização prévia e expressa do
      respectivo titular. <br /><br />

      6.2. Autorização de uso precário. O Usuário entende e aceita que a autorização de uso da Plataforma e de suas
      funcionalidades e ferramentas não poderá ser compreendida como cessão ou atribuição de direitos do
      Multimarcas.online ao Usuário, mas apenas como autorização de uso precário da Plataforma, bem como de suas
      funcionalidades e ferramentas. <br /><br />

      6.3. Ausência de interferência no funcionamento da Plataforma. É vedado ao Usuário utilizar quaisquer
      dispositivos, softwares, e/ou quaisquer outros recursos que possam interferir nas atividades e/ou operações da
      Plataforma. Qualquer interferência, tentativa de interferência, ou qualquer outra conduta que viole ou contrarie
      as normas vigentes de direitos autorais e/ou propriedade industrial e/ou as proibições existentes neste Termos de
      Uso, poderá acarretar a rescisão deste Termos de Uso, suspensão do cadastro do Usuário por tempo indeterminado ou
      ainda seu cancelamento, sem prejuízo de responsabilização cível e criminal do Usuário, bem como do pagamento de
      indenização por perdas e danos eventualmente incorridos, além da não devolução dos valores eventualmente já pagos.
      <br /><br />

      6.4. Responsabilidade sobre informações e conteúdos inseridos na Plataforma. O Usuário é responsável por todas as
      informações enviadas por si ou por meio de seus colaboradores e representantes aos servidores do
      Multimarcas.online através do acesso e uso da Plataforma, assim como por qualquer conteúdo inserido na Plataforma,
      responsabilizando-se integralmente e ilimitadamente por quaisquer violações legais a direitos de terceiros,
      incluindo direitos de propriedade intelectual.
    </p>

    <br />

    <p class="va-text-justify">
      7. POLÍTICA DE PRIVACIDADE <br /><br />
      7.1. Consentimento com o tratamento de dados pessoais. Ao acessar a Plataforma e usar os serviços disponibilizados
      pelo Multimarcas.online, o Usuário expressamente adere à Política de Privacidade e consente e autoriza o
      Multimarcas.online a realizar o tratamento de seus dados pessoais para as finalidades determinadas e previstas na
      Política de Privacidade e de acordo com os termos e condições detalhados neste instrumento e na Política de
      Privacidade. O consentimento do Usuário poderá ser revogado a qualquer tempo, de forma gratuita, devendo, neste
      caso, o Usuário entrar em contato com a equipe do Multimarcas.online por meio dos canais de atendimento oficiais
      indicados na Política de Privacidade. A revogação do consentimento do Usuário implicará a suspensão ou o bloqueio
      de seu acesso à Plataforma, sem qualquer ônus ou penalidade para o Multimarcas.online. A revogação do
      consentimento não terá efeitos retroativos, sendo ratificados os tratamentos de dados pessoais realizados sob
      amparo do consentimento anteriormente manifestado pelo Usuário.
    </p>

    <br />

    <p class="va-text-justify">
      8. INDENIDADE E LIMITAÇÃO DE RESPONSABILIDADE <br /><br />
      8.1. Indenidade. Os Usuários obrigam-se a indenizar e a manter o Multimarcas.online, seus sócios, administradores,
      colaboradores e contratados livres e totalmente indenes por quaisquer gastos, perdas, despesas, danos, reclamações
      e/ou reivindicações incorridos ou sofridos com relação ou em decorrência de qualquer violação deste Termos de Uso
      por parte do Usuário, de seus sócios, administradores e/ou colaboradores. Quaisquer valores devidos aos Usuários
      pelo Multimarcas.online poderão ser retidos e compensados para o pagamento de débitos decorrentes de condenações,
      custas e despesas processuais, além de honorários advocatícios. <br /><br />

      8.2. Limitação de responsabilidade do Multimarcas.online. Os Usuários reconhecem e aceitam que o
      Multimarcas.online não é e não será responsável: <br /><br />

      (a) por qualquer acesso indevido, atividade suspeita na conta do Usuário ou, ainda, pelas eventuais consequências
      e danos decorrentes da falha do Usuário em manter a confidencialidade da senha e/ou da falta ou atraso na
      comunicação ao Multimarcas.online referente a eventual acesso indevido ou uso não autorizado da senha do Usuário
      por terceiros; <br /><br />

      (b) por quaisquer atos ou fatos decorrentes de força maior ou caso fortuito, incluindo, mas não se limitando,
      àqueles casos em que o cumprimento de obrigações aqui previstas se tornar inviável por consequência direta ou
      indireta de suspensão de serviços de terceiros (como eletricidade, telefonia ou internet), incêndios, tempestade,
      lei, regulamento, greves, pandemias, insurreição ou revolta, guerra, ou qualquer outra causa que for inevitável ou
      além do controle razoável do Multimarcas.online; <br /><br />

      (c) por qualquer dano sofrido pelo Usuário em virtude da remoção unilateral de quaisquer dados e informações que
      inseriu na Plataforma, do cancelamento do seu cadastro, bem como da preservação ou fornecimento de informações a
      seu respeito, incluindo aquelas relativas à sua identificação, localização e registros de conexão e/ou de acesso à
      Plataforma, desde que em cumprimento deste Termos de Uso, da Política de Privacidade e/ou de ordens judiciais ou
      administrativas; <br /><br />

      (d) por eventual modificação, suspensão, interrupção ou descontinuação da Plataforma; <br /><br />

      (e) por qualquer declaração ou garantia, expressa ou implícita ou realizada através de negociações com os
      Usuários, incluindo, mas sem limitação: (i) à garantia implícita de adequação a um determinado fim ou à
      não-violação de direitos de terceiros; e (ii) a qualquer garantia com relação à qualidade, precisão, eficácia,
      tempestividade ou integralidade dos serviços oferecidos a partir da Plataforma, ou de que o acesso do Usuário ou o
      uso pelo Usuário dos serviços da Plataforma serão livres de erros, de vírus, de falhas, ininterruptos ou atenderão
      a todos os requisitos do Usuário; <br /><br />

      (f) por pagamentos e/ou recebimentos errôneos e/ou em atraso realizados ou recebidos pelo Usuário em relação a
      fornecedores, clientes, funcionários, agentes, ou qualquer outra pessoa, cabendo ao Usuário conferir os valores
      apontados pela Plataforma, inclusive comissões, sendo de sua responsabilidade apurar e confirmar os valores
      corretos e realizar verificações periódicas nos cálculos e lançamentos informados pelo sistema para fins de
      verificar a sua correção. Os pagamentos e recebimentos realizados pelo Usuário, sem a devida conferência, não
      serão de responsabilidade do Multimarcas.online; <br /><br />

      (g) por eventuais prejuízos decorrentes de lucros cessantes, dano moral, dano à imagem, perda de oportunidade
      comercial e quebra de expectativa; e <br /><br />

      (h) por qualquer ato, fato ou evento que não acarrete ao Usuário o dever de realizar um desembolso efetivo de
      recursos. <br /><br />

      8.2.1. Limite máximo de indenização. Nas hipóteses em que o Multimarcas.online seja considerado responsável por
      danos comprovadamente causados pela Plataforma, a indenização devida ao Usuário estará limitada à quantia
      correspondente ao valor do Plano contratado pelo Usuário na época da violação. O Usuário declara estar de acordo
      com a presente cláusula de limitação quantitativa da responsabilidade do Multimarcas.online. Caso o Usuário não
      esteja de acordo com esta limitação, deverá interromper a utilização da Plataforma imediatamente.
    </p>

    <br />

    <p class="va-text-justify">
      9. PREÇO E PAGAMENTO <br /><br />
      9.1. Mensalidade, Semestralidade ou Anuidade. Em contrapartida ao uso da Plataforma, o Usuário deverá pagar ao
      Multimarcas.online o valor cobrado pelo período do Plano contratado, o que dará ao Usuário acesso à Plataforma
      pelo período de 30 (trinta) dias se Mensalidade, 182 (cento e oitenta e dois) dias se Semestralidade ou 365
      (trezentos e sessenta e cinco) dias se Anuidade, sem interrupções, de acordo com o Plano contratado. <br /><br />

      9.2. Vencimento. Ao contratar um dos Planos, o Usuário escolherá por meio da Plataforma a data de vencimento da
      sua cobrança recorrente, para fins de emissão do boleto bancário ou outra forma de pagamento digital, o qual será
      enviado pelo Multimarcas.online ao Usuário por meio da Plataforma e/ou para o e-mail cadastrado pelo Usuário na
      Plataforma. O pagamento da mensalidade, semestralidade ou anuidade garante ao Usuário a disponibilidade de uso da
      Plataforma independentemente da sua efetiva utilização. O Multimarcas.online não é obrigado a restituir o valor
      pago pelo Usuário em caso de desistência, cancelamento ou ausência de utilização da Plataforma antes de decorridos
      os dias contratados. Com exceção da obrigação de pagamento da mensalidade, semestralidade ou anuidade devida, o
      cancelamento do Plano contratado não gerará multa ou demais encargos adicionais ao Usuário. <br /><br />

      9.3. Reajuste do valor dos Planos. O Multimarcas.online se reserva o direito de unilateralmente reajustar os
      valores dos Planos contratados, as funcionalidades de cada Plano e o espaço de armazenamento de informações na
      Plataforma. O Usuário será avisado sobre os novos preços e características dos Planos, que passarão a vigorar e a
      serem aplicados na próxima mensalidade. Caso o Usuário não concorde com o novo valor do plano contratado ou com
      suas novas funcionalidades, deverá comunicar o cancelamento ao Multimarcas.online antes da realização da cobrança
      do mês subsequente. A contratação de determinado Plano pelo valor anunciado não garante ao Usuário o direito ao
      preço inicialmente contratado por tempo indeterminado, estando sujeito às mudanças de valores e funcionalidades
      eventualmente promovidos pelo Multimarcas.online. <br /><br />

      9.3.1. Reajuste do preço em razão de alteração tributárias. Caso sejam criados novos tributos ou alteradas as
      condições de cálculo e/ou cobrança de tributos já existentes, vindo a impactar os valores da remuneração vigente,
      os custos resultantes deste impacto serão repassados ao Usuário, somando-se aos encargos previamente devidos, o
      que será precedido de notificação prévia pelo Multimarcas.online. <br /><br />

      9.4. Atraso no pagamento. Em caso de atraso no pagamento, o Usuário ficará sujeito ao pagamento das penalidades
      previstas na Cláusula 11.2. Adicionalmente, o Multimarcas.online se reserva o direito de cancelar ou interromper o
      acesso à Plataforma do Usuário inadimplente imediatamente após o vencimento sem pagamento, sem a necessidade de
      prévio aviso. Eventual tolerância do Multimarcas.online em relação ao Usuário inadimplente não retira ou limita o
      direito do Multimarcas.online de suspender e cancelar o acesso do Usuário à Plataforma a qualquer momento após o
      término do prazo para pagamento.
    </p>

    <br />

    <p class="va-text-justify">
      10. VIGÊNCIA E TÉRMINO <br /><br />

      10.1. Prazo de vigência. Este Termos de Uso entra em vigor na data de sua aceitação pelo Usuário e permanece em
      vigor pelo tempo contratado do Plano ou até que seja rescindido ou encerrado por qualquer das partes. <br /><br />

      10.2. Renovação automática do Plano. A renovação do Plano contratado pelo Usuário se dará de maneira automática,
      em 30 (trinta) dias se Mensalidade, em 182 (cento e oitenta e dois) dias se Semestralidade ou em 365 (trezentos e
      sessenta e cinco) dias se Anuidade, através de pagamento pelo mesmo método utilizado no ciclo anterior. Caso o
      Usuário não tenha interesse na renovação, o Usuário deverá cancelar o plano contratado e comunicar o
      Multimarcas.online a esse respeito, antes do término do prazo de 30 (trinta) dias se Mensalidade, de 182 (cento e
      oitenta e dois) dias se Semestralidade ou de 365 (trezentos e sessenta e cinco) dias se Anuidade, hipótese em que
      não ocorrerá a renovação automática e o Multimarcas.online obriga-se a não realizar qualquer tipo de cobrança em
      relação ao próximo período. O cancelamento antecipado do Plano não obrigará o Multimarcas.online a reembolsar a
      mensalidade que tiver sido paga anteriormente. <br /><br />

      10.3. Rescisão imotivada. Este Termos de Uso poderá ser rescindido imotivadamente por qualquer das partes a
      qualquer tempo, sem qualquer ônus ou penalidade, mediante simples envio de comunicação a outra parte, devendo o
      Usuário quitar todos os encargos eventualmente devidos e ainda não pagos no momento do encerramento de seu acesso
      à Plataforma. O cancelamento antecipado por parte do Usuário não obriga o Multimarcas.online a reembolsar
      eventuais valores pagos antecipadamente pelo Usuário. <br /><br />

      10.4. Rescisão motivada. Qualquer das partes poderá rescindir este Termos de Uso, mediante envio de simples
      comunicação, na hipótese de descumprimento deste Termos de Uso ou da legislação aplicável, não sanado no prazo
      específico ou, caso não haja prazo específico e seja possível sanar o descumprimento, no prazo de 5 (cinco) dias
      após o recebimento de comunicação a esse respeito. Neste caso, a parte inocente terá o direito de cobrar da parte
      infratora indenização por todas as perdas e danos eventualmente sofridos, observadas as limitações previstas neste
      instrumento. <br /><br />

      10.5. Efeitos do encerramento ou cancelamento do Plano. Em caso de encerramento ou cancelamento do Plano, por
      qualquer razão, deverá ser observado o seguinte: (a) o acesso às funcionalidades da Plataforma será interrompido e
      bloqueado imediatamente; e (b) o Multimarcas.online poderá excluir todos os arquivos e informações armazenados em
      seus servidores, tendo sido extraídos ou não pelo Usuário antes do cancelamento ou encerramento do Plano,
      observado o disposto na Política de Privacidade.
    </p>

    <br />

    <p class="va-text-justify">
      11. DISPOSIÇÕES GERAIS <br /><br />

      11.1. Violação dos Termos de Uso ou da legislação vigente. No caso de descumprimento, pelo Usuário, de qualquer
      disposição deste Termos de Uso ou da legislação vigente, o Multimarcas.online poderá, independentemente de
      qualquer aviso, notificação ou de qualquer outra formalidade, interromper, suspender ou cancelar, de imediato,
      temporária ou definitivamente, a conta e o acesso do Usuário à Plataforma, sem prejuízo de quaisquer outros
      direitos assegurados ao Multimarcas.online por lei, pelo Termos de Uso e/ou pela Política de Privacidade, nada
      podendo ser reclamado ou cobrado do Multimarcas.online a esse respeito. <br /><br />

      11.2. Atraso no pagamento. O atraso no pagamento de qualquer obrigação prevista neste Termos de Uso sujeitará os
      valores devidos e não pagos à incidência de juros no valor de 1% (um cento) ao mês, multa de 2% (dois por cento) e
      correção monetária positiva segundo IPCA/IBGE ou outro que o venha substituir, caso seja extinto, aplicado pro
      rata dies desde a data do inadimplemento até o efetivo pagamento dos referidos valores. <br /><br />

      11.3. Independência das partes. Este Termos de Uso não estabelece qualquer forma de associação, franquia,
      parceria, consórcio, joint-venture, mandato, vínculo empregatício, societário ou solidariedade, tampouco confere
      às partes autorização para praticar quaisquer atos, representar, contratar ou assumir obrigações em nome da outra
      parte. <br /><br />

      11.4. Cessão. O Usuário não poderá ceder ou transferir a terceiros, a qualquer título, no todo ou em parte, os
      direitos e obrigações decorrentes ou relacionados a este Termos de Uso, salvo se com a expressa e prévia
      autorização por escrito do Multimarcas.online. O Multimarcas.online, por sua vez, está autorizado a ceder ou
      transferir a terceiros direitos e obrigações decorrentes ou relacionados a este Termos de Uso sem a necessidade de
      anuência prévia do Usuário. <br /><br />

      11.5. Revisões ou atualizações. O Multimarcas.online poderá alterar, a qualquer tempo, este Termos de Uso. Fica
      estabelecido que as novas versões dos Termos de Uso entrarão em vigor na data de sua publicação, sendo que o
      Usuário somente poderá continuar a utilizar a Plataforma caso concorde ou não discorde expressamente com as
      referidas alterações. O Usuário poderá, caso não concorde com a referida nova versão, extinguir o seu cadastro da
      Plataforma (i.e. opt. out). Nessa hipótese, o vínculo contratual deixará de existir, a critério exclusivo do
      Usuário, sem qualquer penalidade ao Usuário. O uso da Plataforma, após ter sido comunicado a respeito das
      alterações aos Termos de Uso, será considerado como aceite, pelo Usuário, da nova versão dos Termos de Uso.
      <br /><br />

      11.6. Acordo integral. Este Termos de Uso supera, substitui e prevalece sobre qualquer acordo ou contrato prévio,
      escrito (incluindo eletronicamente) ou verbal, que tenha sido levado a efeito pelas partes com relação aos
      assuntos aqui contemplados. Para que não restem dúvidas, este Termos de Uso não substitui a Política de
      Privacidade. Tais documentos devem ser sempre lidos em conjunto e em caso de conflito entre suas disposições
      deverá prevalecer a regra mais específica. <br /><br />

      11.7. Sucessores. Este Termos de Uso vincula o Usuário e o Multimarcas.online ao seu fiel cumprimento, bem como
      seus sucessores a qualquer título, em caráter irrevogável e irretratável. <br /><br />

      11.8. Necessidade de renúncia expressa e escrita e princípio da conservação. O Multimarcas.online e os Usuários
      declaram e acordam expressamente que: (a) o não exercício ou o atraso no exercício de qualquer direito que lhes
      seja assegurado por este instrumento ou por lei não constituirá novação ou renúncia a tal direito, nem prejudicará
      o eventual exercício do mesmo; (b) a renúncia a qualquer desses direitos somente será válida se formalizada por
      escrito (incluindo eletronicamente), se e quando tal renúncia não for vedada por lei; e (c) a nulidade ou
      invalidade de qualquer das cláusulas deste instrumento não prejudicará a validade e eficácia das demais cláusulas.
      Caso seja decretada a nulidade, anulabilidade ou ineficácia de qualquer das cláusulas deste instrumento, a
      Multimarcas.online tomará todas as providências, inclusive por meio da alteração deste instrumento, para que, em
      conformidade com a legislação em vigor, seja alcançado, na maior extensão possível, o resultado prático a que
      visava este instrumento com a(s) cláusula(s) inquinada(s). <br /><br />

      11.9. Títulos. Os títulos das cláusulas ou capítulos deste Termos de Uso são meramente ilustrativos, e foram
      inseridos para facilitar a compreensão do Usuário. <br /><br />

      11.10. Notificações. Todos os avisos e notificações relacionados a este Termos de Uso deverão ser feitos por
      escrito, sendo encaminhados (a) se para o Multimarcas.online, para os canais de atendimento do Multimarcas.online
      (e-mail, telefone, chat e/ou ticket); e (b) se para o Usuário, ao endereço físico, eletrônico e/ou celular
      constante de seu cadastro na Plataforma e/ou por meio de alertas na área dos Usuários da Plataforma. Os referidos
      avisos e notificações terão validade se enviados por escrito (incluindo eletronicamente) e por qualquer meio que
      permita comprovar o respectivo recebimento. <br /><br />

      11.11. Tributos. Exceto se previsto expressamente de forma diversa neste instrumento, os tributos devidos direta
      ou indiretamente em decorrência da execução deste Termos de Uso e do uso da Plataforma, existentes e/ou que venham
      a ser criados, bem como as respectivas majorações, mudanças de base de cálculo e/ou do período de apuração,
      reajustes, encargos moratórios e/ou obrigações tributárias acessórias, constituem ônus de responsabilidade do
      respectivo sujeito passivo da obrigação tributária, conforme definido na legislação vigente. <br /><br />

      11.12. Legislação aplicável. O Usuário declara-se ciente e concorda que, independentemente do local de onde esteja
      utilizando a Plataforma, este Termos de Uso é regido pelas leis brasileiras. <br /><br />

      11.13. Foro. Em caso de disputas ou desentendimentos a respeito deste Termos de Uso, fica eleito o Foro da Comarca
      de Caxias do Sul, Estado do Rio Grande do Sul, para dirimir quaisquer dúvidas ou controvérsias, com a exclusão de
      qualquer outro, por mais privilegiado que seja ou venha a ser.
    </p>

    <br /><br />

    <p class="va-text-justify">POLÍTICA DE PRIVACIDADE DA PLATAFORMA MULTIMARCAS.ONLINE</p>
    <br /><br />

    <p class="va-text-justify">
      Este instrumento contempla a Política de Privacidade da plataforma de gestão empresarial Multimarcas.online. Antes
      de acessar e usar a Plataforma ou os serviços Multimarcas.online, certifique-se de que compreendeu todas as
      condições estabelecidas neste instrumento. Eventuais dúvidas deverão ser sanadas em contato prévio com a equipe do
      Multimarcas.online, por meio do e-mail privacidade@multimarcas.online. Após ler, compreender e concordar com todo
      o conteúdo desta Política de Privacidade, você poderá aderir a ela. Caso você não concorde com esta Política de
      Privacidade, você deverá imediatamente suspender o uso da Plataforma e dos serviços Multimarcas.online. Você
      somente poderá utilizar a Plataforma e os demais serviços oferecidos pelo Multimarcas.online caso aceite
      integralmente esta Política de Privacidade. A utilização da Plataforma ou dos demais serviços oferecidos pelo
      Multimarcas.online implica a aceitação plena, irrestrita e sem reservas de todos os termos e condições previstos
      neste documento, inclusive no caso de eventuais revisões ou publicação de novas versões. No caso de revisões ou
      publicações de novas versões, você será avisado previamente e, caso não concorde com as alterações, deverá
      descontinuar o uso da Plataforma. O uso continuado da Plataforma ou dos demais serviços oferecidos pelo
      Multimarcas.online, após a revisão da Política de Privacidade, implica aceitação das alterações, sem ressalvas.
    </p>

    <br />

    <p class="va-text-justify">
      1 – DEFINIÇÕES <br /><br />
      1.1. Definições. Os termos iniciados em letra maiúscula indicados a seguir serão utilizados com o significado
      detalhado abaixo: <br /><br />

      a. “Multimarcas.online”: é a Wecast Solucoes em Tecnologia e Gestao Digital, inscrita no CNPJ sob o n.º
      04.124.535/0001-25, com sede na Rua Luiz Michielon, 1212 CEP 95074-000, Bairro Cruzeiro, no Município de Caxias do
      Sul, Estado do Rio Grande do Sul. <br /><br />

      b. “Controlador”: é a pessoa, natural ou jurídica, a quem competem as decisões referentes ao Tratamento de Dados
      Pessoais. <br /><br />

      c. “Dado Não Pessoal”: são informações fornecidas, coletadas ou processadas pelo Multimarcas.online ou pelos
      Usuários que não permitem identificar uma pessoa natural, tais como dados técnicos, estatísticos e agregados.
      <br /><br />

      d. “Dado Pessoal”: são informações fornecidas, coletadas ou processadas pelo Multimarcas.online ou pelos Usuários
      que identificam ou permitem identificar uma pessoa natural, tais como seu nome, e-mail e telefone. <br /><br />

      e. “Dado Pessoal Sensível”: são Dados Pessoais sobre origem racial ou étnica, convicção religiosa, opinião
      política, filiação a sindicato ou a organização de caráter religioso, filosófico ou político, dado referente à
      saúde ou à vida sexual, dado genético ou biométrico, quando vinculado a uma pessoa natural. <br /><br />

      f. “Operador”: é a pessoa, natural ou jurídica, que realiza operações de Tratamento de Dados Pessoais em nome do
      Controlador. <br /><br />

      g. “Parceiros”: são os parceiros do Multimarcas.online cadastrados no website do Multimarcas.online para prestação
      de serviços de indicação e aproximação do Multimarcas.online com novos clientes. Os Parceiros, que podem ser tanto
      pessoas físicas como jurídicas, são identificados no momento de preenchimento do formulário para participação no
      programa de indicação de clientes para o Multimarcas.online. <br /><br />

      h. “Plataforma”: é a ferramenta de gestão empresarial constituída por uma aplicação de web software de
      responsabilidade, propriedade e operação do Multimarcas.online. Para os fins desta Política de Privacidade, a
      definição de “Plataforma” também inclui o website e demais portais eletrônicos mantidos pelo Multimarcas.online
      para prestação de serviços ou realização de parceiras, inclusive o website mantido para cadastro dos Parceiros.
      <br /><br />

      i. “Tratamento”: são quaisquer operações envolvendo Dados Pessoais e/ou Dados Não Pessoais, tais como coleta,
      produção, recepção, classificação, utilização, acesso, reprodução, transmissão, distribuição, processamento,
      arquivamento, armazenamento, eliminação, avaliação, controle, modificação, comunicação, transferência, difusão ou
      extração. <br /><br />

      j. “Termos de Uso”: é o instrumento que disciplina os termos e as condições gerais que regerão o acesso e o uso da
      Plataforma pelos Usuários. O Multimarcas.online poderá estabelecer Termos de Uso específicos e aplicáveis a
      determinados produtos ou funcionalidades, conforme o caso, que complementarão e prevalecerão sobre os Termos de
      Uso gerais. <br /><br />

      k. “Usuário”: são os clientes do Multimarcas.online cadastrados na Plataforma, que podem ser tanto pessoas físicas
      como jurídicas, pagantes ou não. Os clientes são identificados no momento de preenchimento do formulário para
      acesso e uso da Plataforma.
    </p>

    <br />

    <p class="va-text-justify">
      2 – OBJETO <br /><br />
      2.1. Objeto. Esta Política de Privacidade tem por objeto disciplinar os termos e as condições gerais que regerão o
      Tratamento de Dados Pessoais e de Dados Não Pessoais pelo Multimarcas.online e é aplicável aos Usuários, eventuais
      contrapartes dos Usuários e aos Parceiros, que tenham seus Dados Pessoais inseridos, coletados ou processados por
      meio da Plataforma.
    </p>

    <br />

    <p class="va-text-justify">
      3 – CONSENTIMENTO DO TITULAR <br /><br />

      3.1. Consentimento dos Usuários e Parceiros. Ao acessar a Plataforma e usar os serviços disponibilizados pelo
      Multimarcas.online, o Usuário ou o Parceiro, conforme aplicável, expressamente consente e autoriza o
      Multimarcas.online a realizar o Tratamento de seus Dados Pessoais para as finalidades determinadas e previstas
      nesta Política de Privacidade. O consentimento do Usuário ou do Parceiro, conforme o caso, poderá ser revogado a
      qualquer tempo, de forma gratuita, devendo, neste caso, o Usuário ou o Parceiro entrar em contato com a equipe do
      Multimarcas.online por meio dos canais de comunicação oficiais informados nesta Política de Privacidade. A
      revogação do consentimento do Usuário ou do Parceiro implicará a suspensão ou o bloqueio de seu acesso à
      Plataforma, sem qualquer ônus ou penalidade para o Multimarcas.online. A revogação do consentimento não terá
      efeitos retroativos, sendo ratificados os Tratamentos de dados pessoais realizados sob amparo do consentimento
      anteriormente manifestado pelo Usuário ou pelo Parceiro. <br /><br />

      3.2. Consentimento de contrapartes do Usuário. Ao acessar a Plataforma e usar os serviços disponibilizados pelo
      Multimarcas.online, o Usuário declara e garante que obteve o consentimento expresso e por escrito (que poderá ser
      formalizado por meio eletrônico) de todos os titulares de Dados Pessoais que sejam contrapartes do Usuário (e.g.,
      clientes, fornecedores, prestadores de serviços, empregados, entre outros), e que tenham seus Dados Pessoais
      inseridos, coletados ou processados por meio da Plataforma em nome do Usuário.
    </p>

    <br />

    <p class="va-text-justify">
      4 – DADOS COLETADOS <br /><br />

      4.1. Dados de Usuários, de contrapartes dos Usuários e dos Parceiros. Ao utilizar a Plataforma e interagir com o
      Multimarcas.online, o Multimarcas.online poderá realizar o Tratamento de Dados Pessoais e de Dados Não Pessoais
      (a) dos Usuários, (b) de eventuais contrapartes dos Usuários em suas operações comerciais e empresariais, tais
      como clientes, fornecedores, prestadores de serviços, empregados, entre outros, e (c) dos Parceiros. <br /><br />

      4.2. Atuação do Multimarcas.online como Controlador ou Operador de Dados Pessoais. O Multimarcas.online realizará
      o Tratamento de Dados Pessoais em nome próprio e/ou em nome do Usuário. Quando o Multimarcas.online realizar o
      Tratamento de Dados Pessoais em nome próprio, o Multimarcas.online atuará como Controlador. Quando o
      Multimarcas.online realizar o Tratamento de Dados Pessoais em nome do Usuário, o Multimarcas.online atuará como
      Operador de Dados Pessoais em nome do Usuário. <br /><br />

      4.3. Responsabilidades do Usuário como Controlador de Dados Pessoais. O Multimarcas.online poderá realizar o
      Tratamento de Dados Pessoais em nome dos Usuários quando estes incluírem Dados Pessoais de terceiros na Plataforma
      ou usarem a Plataforma para realizar o Tratamento de Dados Pessoais de terceiros. O Multimarcas.online não tem
      controle sobre quais Dados Pessoais de terceiros o Usuário poderá inserir, coletar ou processar por meio da
      Plataforma, nem como tais Dados Pessoais serão utilizados pelo Usuário. Os Dados Pessoais de terceiros inseridos
      pelo Usuário ou coletados e processados pelo Usuário por meio da Plataforma ficarão à disposição dos Usuários,
      cabendo aos Usuários toda e qualquer responsabilidade a respeito da forma pela qual tais Dados Pessoais são objeto
      de Tratamento, inclusive pela obtenção de consentimento prévio e por escrito (que poderá ser formalizado por meio
      eletrônico) por parte do titular, nos termos da legislação aplicável, devendo manter o Multimarcas.online indene e
      livre de qualquer responsabilidade a esse respeito. <br /><br />

      4.4. Responsabilidade do Multimarcas.online perante contrapartes dos Usuários. O Multimarcas.online não tem
      qualquer relação com as contrapartes dos Usuários que eventualmente tenham seus Dados Pessoais inseridos ou
      coletados pelo ou para o uso da Plataforma. Os titulares de tais Dados Pessoais devem exercer seus direitos sobre
      seus Dados Pessoais diretamente perante os Usuários, podendo o Multimarcas.online operacionalizar requisições de
      bloqueio ou eliminação de Dados Pessoais em benefício de tais terceiros, quando o Controlador dos Dados Pessoais
      se negar de forma imotivada a fazê-lo e desde que tal operacionalização seja possível tecnicamente. Em caso de
      recebimento de pedidos de bloqueios ou eliminação de Dados Pessoais de terceiros, o Multimarcas.online deverá
      responder ao terceiro e encaminhar à solicitação ao Usuário em prazo razoável, para que o Usuário adote as medidas
      adequadas e necessárias, nos termos da legislação aplicável. <br /><br />

      4.4.1. Obrigação do Usuário de comunicação a respeito de solicitações de titulares de Dados Pessoais. Caso o
      Usuário receba qualquer solicitação de titulares de Dados Pessoais a respeito de Dados Pessoais que tenham sido
      objeto de Tratamento por meio do uso da Plataforma, o Usuário deverá comunicar e manter o Multimarcas.online
      informado a respeito de todas as medidas adotadas pelo Usuário para resguardar os direitos dos titulares de Dados
      Pessoais, nos termos desta Política de Privacidade e da legislação aplicável. <br /><br />

      4.4.2. Auditoria. Exclusivamente com o objetivo de verificar o adequado e pontual cumprimento desta Política de
      Privacidade e da legislação de proteção de dados pessoais em relação aos Dados Pessoais objeto de Tratamento por
      meio da Plataforma, o Multimarcas.online terá o direito, mas não a obrigação, de realizar auditorias nos sistemas
      eletrônicos mantidos pelos Usuários e Parceiros para acesso à Plataforma, assim como poderá solicitar a
      apresentação de documentos e relatórios que revelem o adequado cumprimento. Os Usuários e Parceiros deverão
      indenizar a Multimarcas.online por eventuais perdas e danos decorrentes do descumprimento das regras de proteção
      de dados pessoais a que tenham dado causa ou concorrido para tanto. <br /><br />

      4.5. Detalhamento dos Dados Pessoais coletados pelo Multimarcas.online. O Multimarcas.online poderá realizar o
      Tratamento dos seguintes Dados Pessoais: <br /><br />

      a. Dados de contato: nome, profissão, CPF, endereço, e-mail e telefone fixo e celular. <br /><br />

      b. Dados da conta na Plataforma: nome de usuário e senha. <br /><br />

      c. Dados de faturamento: endereço de cobrança, método de pagamento, dados de conta bancária, número de cartão de
      crédito e data de expiração. <br /><br />

      d. Dados de navegação: endereço IP, localização geográfica e identificador do dispositivo. <br /><br />

      e. Dados de contas conectadas com provedores de terceiros ou redes sociais: nome, e-mail, data de nascimento,
      telefone e e-mail. <br /><br />

      f. Dados de Veículos: ano, modelo, versão, proprietário, valor, situação perante órgãos públicos. <br /><br />

      4.5.1. Dados Pessoais Sensíveis. O Multimarcas.online também poderá realizar o Tratamento de Dados Pessoais
      Sensíveis. Se isso acontecer, o Tratamento de tais Dados Pessoais Sensíveis será precedido de prévio e expresso
      consentimento do Usuário, do Parceiro ou do titular, conforme o caso. Caso o Usuário também venha a realizar o
      Tratamento de Dados Pessoais Sensíveis de terceiros por meio da Plataforma, o Usuário também deverá garantir que o
      Tratamento de tais Dados Pessoais Sensíveis somente será realizado se precedido de prévio e expresso consentimento
      do titular, por escrito, que poderá ser manifestado inclusive de forma eletrônica. <br /><br />

      4.6. Detalhamento dos Dados Não Pessoais coletados pelo Multimarcas.online. O Multimarcas.online poderá realizar o
      Tratamento dos seguintes Dados Não Pessoais: (a) histórico de navegação, dados sobre sequência de cliques,
      informações sobre data e horário de acesso a páginas, total de visitas, interações com outras páginas e métodos
      utilizados para deixar a página, tempo de resposta e tempo total de visita; e (b) dados não identificadores sobre
      dispositivos eletrônicos (incluindo fabricante e modelo), sistema operacional, navegador de internet, resolução de
      tela, idioma, e rede Wi-Fi. <br /><br />

      4.7. Combinação de Dados Pessoais e de Dados Não Pessoais. Caso o Multimarcas.online combine Dados Pessoais e
      Dados Não Pessoais, a informação combinada será tratada como Dado Pessoal pelo Multimarcas.online enquanto essa
      informação permanecer combinada ou não for anonimizada. <br /><br />

      4.8. Outros Dados coletados pelo Multimarcas.online. Além dos Dados Pessoais e dos Dados Não Pessoais, o
      Multimarcas.online também poderá coletar, processar e usar outros dados dos Usuários ou dos Parceiros, notadamente
      dados relacionados com pessoas jurídicas, tais como CNPJ e outros informações financeiras e de faturamento para
      assegurar determinados pagamentos e a emissões de boletos bancários e notas fiscais. <br /><br />

      4.9. Uso de Dados Não Pessoais. O Multimarcas.online poderá realizar o tratamento de Dados Não Pessoais e outros
      dados que não permitam a identificação de uma pessoa natural como bem lhe aprouver, a seu discricionário critério,
      sem a necessidade de qualquer autorização prévia ou comunicação com os Usuários ou Parceiros, observados apenas os
      eventuais limites previstos na legislação aplicável. <br /><br />

      4.10. Meios de coleta de dados. O Multimarcas.online poderá coletar Dados Pessoais e Dados Não Pessoais das
      seguintes formas: (a) por meio do uso dos serviços disponibilizados pelo Multimarcas.online, quando o Usuário ou o
      Parceiro navega na Plataforma, envia informações e conteúdo pela Plataforma ou entra em contato com o
      Multimarcas.online, por meio de qualquer canal de atendimento; (b) por meio do fornecimento voluntário de dados
      pelos Usuários ou pelos Parceiros, quando o Usuário ou o Parceiro informa seus dados para fins de registro na
      Plataforma, envia documentos para o Multimarcas.online ou entra em contato com o Multimarcas.online, por meio de
      qualquer canal de atendimento; e (c) por meio de fontes independentes, quando o Multimarcas.online realiza
      pesquisas perante instituições bancárias, processadores de pagamentos, empresas ou agências de proteção de
      crédito, entre outros.
    </p>

    <br />

    <p class="va-text-justify">
      5 – FINALIDADES E REQUISITOS PARA TRATAMENTO DE DADOS PESSOAIS <br /><br />

      5.1. Finalidades. O Multimarcas.online realizará o Tratamento de Dados Pessoais para o atendimento das finalidades
      determinadas e específicas descritas abaixo: <br /><br />

      a. Prestação de serviços: para disponibilizar e operar todas as funcionalidades e serviços da Plataforma.
      <br /><br />

      b. Aprimoramento de serviços: para desenvolver e melhorar as funcionalidades e serviços da Plataforma, experiência
      e a comunicação com os Usuários e com os Parceiros, inclusive para criação de novas funcionalidades, serviços ou
      produtos. <br /><br />

      c. Assistência técnica: para solucionar problemas técnicos, falhas e erros, inclusive de segurança, que venham a
      ocorrer no âmbito da Plataforma. <br /><br />

      d. Comunicação com os Usuários e Parceiros: para permitir a comunicação com os Usuários e Parceiros, inclusive por
      meio de avisos gerais ou personalizados, notificações, comunicados, alteração de prazos e políticas. <br /><br />

      e. Publicidade: para envio de anúncios ou material promocional ou publicitário, inclusive de terceiros e parceiros
      do Multimarcas.online. <br /><br />

      f. Estatísticas: para análise de dados estatísticos e realização de pesquisas sobre produtos, serviços e
      comunicações, que podem ser usados pelo Multimarcas.online ou por seus parceiros e contratados. <br /><br />

      5.2. Requisitos. O Multimarcas.online somente realizará o Tratamento de Dados Pessoais se e quando for necessário
      para (a) cumprir um contrato celebrado com o Usuário ou com o Parceiro, conforme o caso, tais como os Termos de
      Uso da Plataforma, no caso dos Usuários; (b) cumprir uma obrigação decorrente de quaisquer leis e regulamentos
      aplicáveis a que o Multimarcas.online e/ou os Usuários ou Parceiros estejam sujeitos; e (c) atender aos interesses
      legítimos do Multimarcas.online, tais como para manter e aprimorar os serviços que prestamos aos Usuários.
      <br /><br />

      5.3. Gravação de ligações ou conversas via aplicativos. Para fins de qualificação, treinamento e para a segurança
      dos Usuários e Parceiros, o Multimarcas.online pode monitorar ou gravar conversas com os Usuários, com os
      Parceiros ou com pessoas agindo em nome dos Usuários e Parceiros. Ao se comunicar com o Multimarcas.online, os
      Usuários e os Parceiros entendem, concordam e autorizam que as comunicações podem ser ouvidas, monitoradas e/ou
      gravadas sem aviso ou notificação prévios.
    </p>

    <br />

    <p class="va-text-justify">
      6 – ARMAZENAMENTO E TÉRMINO DO TRATAMENTO DE DADOS PESSOAIS <br /><br />

      6.1. Local de armazenamento. Os Dados Pessoais e os Dados Não Pessoais objeto de Tratamento pelo
      Multimarcas.online podem ser armazenados em centros de armazenamento de dados físicos ou virtuais, em data center
      ou por meio de serviços disponibilizados por parceiros que podem estar localizados no Brasil e/ou em outros
      países, tais como Estados Unidos da América e países da União Europeia. <br /><br />

      6.2. Prazo de armazenamento. Os Dados Pessoais objeto de Tratamento pelo Multimarcas.online serão armazenados
      enquanto o Usuário ou o Parceiro, conforme o caso, mantiver uma conta ativa na Plataforma e pelo tempo necessário
      para que o Multimarcas.online possa cumprir com as obrigações assumidas perante os Usuários e Parceiros, nos
      termos deste instrumento e dos Termos de Uso, e perante qualquer autoridade pública, conforme determinado pela
      legislação e regulamentação aplicáveis. A partir do momento em que o armazenamento dos Dados Pessoais deixar de
      ser necessário, o Multimarcas.online realizará a remoção e a eliminação de tais dados. <br /><br />

      6.3. Encerramento do uso da Plataforma, revogação de consentimento e término do Tratamento de Dados Pessoais. Caso
      o Usuário ou o Parceiro deixe de utilizar os serviços oferecidos na Plataforma por qualquer razão ou revogue o seu
      consentimento, os seus Dados Pessoais serão anonimizados ou excluídos definitivamente da Plataforma e dos sistemas
      de armazenamento do Multimarcas.online, exceto se a retenção e o armazenamento de Dados Pessoais for necessário
      para (a) cumprimento de obrigação legal ou contratual, (b) atendimento de interesses legítimos do
      Multimarcas.online ou (c) exercício regular de direitos em processo judicial, administrativo ou arbitral. Nesses
      casos, a retenção e o armazenamento de dados continuarão a ser realizados. Os Dados Pessoais também poderão ser
      anonimizadaos pelo Multimarcas.online a qualquer momento, hipótese em que poderão ser mantidos pelo
      Multimarcas.online para seu uso exclusivo mesmo após o término da relação com o titular dos Dados Pessoais.
    </p>

    <br />

    <p class="va-text-justify">
      7 – SEGURANÇA DE DADOS <br /><br />

      7.1. Medidas de proteção de dados. O Multimarcas.online emprega seus melhores esforços para proteger os Dados
      Pessoais e os Dados Não Pessoais objeto de Tratamento contra perda, roubo ou qualquer modalidade de uso ou acesso
      indevido e não autorizado, divulgação, alteração e destruição. O Multimarcas.online aplica as melhores práticas de
      segurança no Tratamento de Dados Pessoais e de Dados Não Pessoais, tais como criptografia, monitoramento e testes
      de segurança periódicos, firewall, entre outros. <br /><br />

      7.2. Ausência de garantias. A despeito de todas as medidas de segurança adotadas pelo Multimarcas.online, não é
      possível garantir e o Multimarcas.online não garante a não ocorrência de vazamentos, interceptações e violações de
      sistemas e bases de dados. Nada nesta Política de Privacidade ou nos Termos de Uso deverá ser interpretado nesse
      sentido. <br /><br />

      7.3. Tratamento de incidentes de segurança. Na hipótese de ocorrência de um incidente de segurança que resulte em
      destruição, perda, alteração, acesso não autorizado ou vazamento de Dados Pessoais, o Multimarcas.online avaliará
      os riscos e eventuais danos causados e deverá comunicar, em prazo razoável, o titular e as autoridades públicas
      competentes a esse respeito. O Multimarcas.online adotará todas as medidas disponíveis e razoáveis para mitigar
      eventuais danos causados aos titulares de Dados Pessoais que tenham sido objeto de Tratamento pelo
      Multimarcas.online. <br /><br />

      7.4. Responsabilidades dos Usuário e dos Parceiros por incidentes de segurança. É responsabilidade única e
      exclusiva dos Usuários ou dos Parceiros, conforme o caso, qualquer incidente de segurança que ocorra em sua conta
      ou com seus Dados Pessoais, ou com Dados Pessoais de terceiros que o Usuário venha a imputar ou processar na
      Plataforma, em razão de atos ou fatos nos quais o Usuário ou o Parceiro concorra com culpa exclusiva ou
      concorrente, tais como atos de divulgação de suas informações de acesso (login e senha) para terceiros, utilização
      de computadores de acesso público (e.g., lan house) ou qualquer outra forma de conexão com a internet que não seja
      privada e segura. Nesses casos, nenhuma responsabilidade poderá ser imputada ao Multimarcas.online ou aos seus
      parceiros provedores de serviços de segurança e de armazenamento de dados.
    </p>

    <br />

    <p class="va-text-justify">
      8 – COMPARTILHAMENTO DE DADOS COM TERCEIROS <br /><br />

      8.1. Consentimento. Ao acessar a Plataforma e usar os serviços disponibilizados pelo Multimarcas.online, os
      Usuários e os Parceiros expressamente consentem e autorizam o Multimarcas.online a realizar o Compartilhamento de
      seus Dados Pessoais para as finalidades determinadas e previstas abaixo. Caso os Usuários e os Parceiros não
      concordem com o compartilhamento de seus Dados Pessoais, deverão imediatamente suspender o acesso e o uso da
      Plataforma e comunicar, por escrito, o Multimarcas.online a esse respeito. A revogação do consentimento não terá
      efeitos retroativos, sendo ratificados os Tratamentos de dados pessoais realizados sob amparo do consentimento
      anteriormente manifestado pelos Usuários e/ou pelos Parceiros, conforme o caso. <br /><br />

      8.2. Compartilhamento de Dados Pessoais com contratados e empresas parceiras. O Multimarcas.online poderá
      disponibilizar ou compartilhar Dados Pessoais com contratados, desenvolvedores de software e prestadores de
      serviços que prestam serviços para o Multimarcas.online ou atuam em conjunto com o Multimarcas.online para
      executar determinadas funcionalidades e atividades no âmbito da Plataforma, incluindo agências de marketing,
      prestadores de serviços de bancos de dados, prestadores de serviços de recuperação de dados após desastres e de
      organização de cópias de segurança, processadores e meios de pagamentos, instituições financeiras, serviços de
      e-mail, serviços de acesso remoto, consultores jurídicos e financeiros, entre outros. O acesso a Dados Pessoais
      por tais terceiros terá como finalidade permitir o uso e o desenvolvimento da Plataforma, a adequada prestação de
      serviços pelo Multimarcas.online e o atendimento de contratos e obrigações legais e regulamentares. <br /><br />

      8.3. Compartilhamento de Dados Pessoais com empresas do mesmo grupo. O Multimarcas.online poderá disponibilizar ou
      compartilhar Dados Pessoais com subsidiárias, controladas, controladoras, investidas e demais empresas de seu
      grupo econômico com as finalidades de: (a) desenvolvimento de novos produtos e serviços; (b) oferta de produtos e
      serviços que melhor atendam aos interesses dos Usuários; e (c) geração de dados estatísticos e agregados acerca do
      uso da Plataforma e dos perfis dos Usuários. <br /><br />

      8.4. Compartilhamento de Dados Pessoais em operações societárias. O Multimarcas.online poderá vender ou comprar
      outras empresas e ativos, assim como poderá ser vendida ou comprada por outras empresas, no Brasil ou no exterior.
      Em caso de venda, cisão, fusão, incorporação, transformação ou qualquer outra operação societária, os Dados
      Pessoais dos Usuários, de suas contrapartes e/ou dos Parceiros poderão ser compartilhados com terceiros ou poderão
      fazer parte dos ativos intangíveis transferidos ou alienados, independentemente de qualquer aviso prévio ou
      autorização. <br /><br />

      8.5. Compartilhamento de Dados Pessoais com autoridades públicas. Sempre que exigido por lei ou por determinação
      de autoridade pública, o Multimarcas.online poderá divulgar ou compartilhar, no todo ou em parte, com ou sem aviso
      prévio, os Dados Pessoais dos Usuários, de suas contrapartes e/ou dos Parceiros. O Multimarcas.online também
      poderá compartilhar Dados Pessoais para responder a processos judiciais ou para participar de eventuais litígios
      ou demandas judiciais ou administrativas de qualquer natureza. <br /><br />

      8.6. Transferência internacional de Dados Pessoais. O Multimarcas.online poderá realizar transferências
      internacionais de Dados Pessoais com o objetivo de disponibilizar algumas das funcionalidades da Plataforma ou
      para obter informações que possam ajudar a desenvolver e aprimorar a Plataforma. Neste caso, o Multimarcas.online
      deverá fazer com que os parceiros internacionais que venham a receber Dados Pessoais utilizem critérios e padrões
      de segurança compatíveis com aqueles previstos nesta Política de Privacidade. <br /><br />

      8.7. Proteção de direitos e segurança. O Multimarcas.online se reserva o direito de compartilhar Dados Pessoais
      e/ou Dados Não Pessoais sempre que acreditar e tiver motivos suficientes para considerar que a atividade do
      Usuário ou do Parceiro seja suspeita, ilegal ou prejudicial ao Multimarcas.online, aos demais Usuários, Parceiros
      ou a quaisquer terceiros. <br /><br />

      8.8. Compartilhamento de Dados Não Pessoais. Nada nesta Política de Privacidade limita ou restringe o
      compartilhamento de Dados Não Pessoais, a exclusivo e discricionário critério do Multimarcas.online, sem a
      necessidade de qualquer autorização ou comunicação prévia.
    </p>

    <br />

    <p class="va-text-justify">
      9 – USO DE COOKIES E OUTRAS TECNOLOGIAS DE RASTREAMENTO <br /><br />

      9.1. Finalidades do uso de cookies e tecnologias de rastreamento. O Multimarcas.online poderá usar cookies e
      outras tecnologias de monitoramento ou rastreamento com a finalidade de (a) disponibilizar e operar as
      funcionalidades e serviços da Plataforma; (b) melhorar a experiência dos Usuários e dos Parceiros na Plataforma;
      (c) identificar problemas técnicos e falhas; e (d) monitorar e melhorar o desempenho geral da Plataforma.
      <br /><br />

      9.2. Exclusão ou bloqueio de cookies e tecnologias de rastreamento. Caso o Usuário ou o Parceiro tenha interesse
      em excluir ou bloquear determinado cookie ou outra tecnologia de rastreamento, o Usuário ou o Parceiro, conforme
      aplicável, deverá verificar o arquivo ou diretório que armazena o cookie ou demais tecnologia de rastreamento e
      então deverá excluí-lo ou bloqueá-lo. A exclusão ou o bloqueio de cookies e demais tecnologias de rastreamento
      poderá afetar o normal e adequado funcionamento da Plataforma, inclusive com prejuízos para a experiência de
      navegação do Usuário ou do Parceiro, conforme aplicável.
    </p>

    <br />

    <p class="va-text-justify">
      10 – DIREITOS DO TITULAR SOBRE SEUS DADOS PESSOAIS <br /><br />

      10.1. Direitos do titular. Por meio dos canais de comunicação oficiais do Multimarcas.online, conforme previsto
      abaixo, os titulares de Dados Pessoais objeto de Tratamento pelo Multimarcas.online na condição de Controlador
      poderão solicitar à Multimarcas.online, a qualquer momento e mediante requisição por escrito enviada para os
      canais de comunicação oficiais do Multimarcas.online: (a) confirmação da existência de Tratamento de Dados
      Pessoais; (b) acesso a seus Dados Pessoais; (c) correção de Dados Pessoais incompletos, inexatos ou
      desatualizados; (d) anonimização, bloqueio ou eliminação de Dados Pessoais desnecessários, excessivos ou tratados
      em desconformidade com esta Política de Privacidade ou com a legislação aplicável; (e) eliminação de Dados
      Pessoais, ressalvadas as hipóteses em que tal eliminação não puder ser realizada, nos termos desta Política de
      Privacidade e da legislação aplicável; (f) informação sobre as entidades públicas e privadas com as quais seus
      Dados Pessoais foram compartilhados; (g) informação sobre a possibilidade de não fornecer ou revogar o
      consentimento para Tratamento de seus Dados Pessoais e eventuais consequências negativas. <br /><br />

      10.2. Eliminação de Dados Pessoais. Caso o titular solicite a exclusão de seus Dados Pessoais, o
      Multimarcas.online estará autorizado a excluir ou anonimizar os Dados Pessoais do solicitante, ainda que isso
      implique na remoção de todos os Dados Pessoais da Plataforma em caráter definitivo. Caso os Dados Pessoais sejam
      também mantidos em arquivos e sistemas internos dos Usuários, caberá única e exclusivamente aos Usuários adotarem
      as providências para exclusão ou anonimização de tais Dados Pessoais. <br /><br />

      10.3. Atendimento de solicitações dos titulares de Dados Pessoais. Antes de atender a qualquer solicitação dos
      titulares de Dados Pessoais, o Multimarcas.online poderá solicitar informações adicionais para confirmar a
      identidade do solicitante e para fins de segurança. Caso a solicitação seja infundada ou não tenha respaldo legal
      ou contratual, o Multimarcas.online também poderá cobrar uma taxa, solicitar o reembolso dos custos incorridos
      para o atendimento de tal solicitação ou simplesmente recusar o atendimento da solicitação. Nas hipóteses em que o
      Multimarcas.online não seja o Controlador dos Dados Pessoais do solicitante, o Multimarcas.online informará o
      solicitante a respeito de sua posição como Operadora de Dados Pessoais e, se possível, indicará o Controlador,
      responsável por atender a solicitação do titular dos Dados Pessoais. <br /><br />

      10.4. Não eliminação de Dados Pessoais. Desde que estejam presentes quaisquer dos fundamentos previstos abaixo, o
      Multimarcas.online se reserva o direito de não eliminar os Dados Pessoais do Usuário ou de suas contrapartes,
      mesmo após o recebimento de solicitação nesse sentido: (a) cumprimento de obrigação legal ou contratual, inclusive
      perante outros Usuários; (b) atendimento de interesses legítimos do Multimarcas.online; ou (c) exercício regular
      de direitos em processo judicial, administrativo ou arbitral.
    </p>

    <br />

    <p class="va-text-justify">
      11 – DÚVIDAS OU QUESTÕES <br /><br />

      11.1. Contato. Em caso de dúvidas ou questões sobre esta Política de Privacidade ou sobre o exercício dos direitos
      previstos neste instrumento ou na legislação vigente no que diz respeito à proteção de dados pessoais, por favor
      entre em contato com a equipe do Multimarcas.online por meio do e-mail privacidade@multimarcas.online.
    </p>

    <br />

    <p class="va-text-justify">
      12 – DISPOSIÇÕES GERAIS <br /><br />

      12.1. Violação da Política de Privacidade. No caso de descumprimento, pelo Usuário e/ou pelo Parceiro, de qualquer
      disposição desta Política de Privacidade, o Multimarcas.online poderá, independentemente de qualquer aviso,
      notificação ou de qualquer outra formalidade, interromper, suspender ou cancelar, de imediato, temporária ou
      definitivamente, a conta e o acesso do Usuário e/ou do Parceiro à Plataforma, sem prejuízo de quaisquer outros
      direitos assegurados ao Multimarcas.online por lei, pelos Termos de Uso e/ou por esta Política de Privacidade.
      <br /><br />

      12.2. Revisões ou atualizações. O Multimarcas.online poderá alterar ou revisar, a qualquer tempo, esta Política de
      Privacidade. Fica estabelecido que as novas versões desta Política de Privacidade entrarão em vigor na data de sua
      publicação, sendo que os Usuários e os Parceiros somente poderão continuar a utilizar a Plataforma caso concordem
      ou não discordem expressamente com as referidas alterações. Os Usuários e os Parceiros poderão, caso não concordem
      com a referida nova versão, extinguir o seu cadastro da Plataforma (i.e. opt. out). Nessa hipótese, o vínculo
      contratual deixará de existir, a critério exclusivo do Usuário ou do Parceiro em questão, sem qualquer penalidade
      ao Usuário e/ou ao Parceiro, conforme o caso, e ao Multimarcas.online. O uso da Plataforma, após ter sido
      comunicado a respeito das alterações, será considerado como aceite, pelo Usuário ou pelo Parceiro, conforme o
      caso, da nova versão da Política de Privacidade. <br /><br />

      12.3. Acordo integral. Esta Política de Privacidade supera, substitui e prevalece sobre qualquer acordo ou
      contrato prévio, escrito (incluindo eletronicamente) ou verbal, que tenha sido levado a efeito pelas partes com
      relação aos assuntos aqui contemplados. Para que não restem dúvidas, esta Política de Privacidade não substitui os
      Termos de Uso da Plataforma. Tais documentos devem ser sempre lidos em conjunto e em caso de conflito entre suas
      disposições deverá prevalecer a regra mais específica. <br /><br />

      12.4. Sucessores. Esta Política de Privacidade vincula o Usuário, o Parceiro e o Multimarcas.online ao seu fiel
      cumprimento, bem como seus sucessores a qualquer título, em caráter irrevogável e irretratável. <br /><br />

      12.5. Necessidade de renúncia expressa e escrita e princípio da conservação. O Multimarcas.online, os Usuários e
      os Parceiros declaram e acordam expressamente que: (a) o não exercício ou o atraso no exercício de qualquer
      direito que lhes seja assegurado por este instrumento ou por lei não constituirá novação ou renúncia a tal
      direito, nem prejudicará o eventual exercício do mesmo; (b) a renúncia a qualquer desses direitos somente será
      válida se formalizada por escrito (inclusive eletronicamente), se e quando tal renúncia não for vedada por lei; e
      (c) a nulidade ou invalidade de qualquer das cláusulas deste instrumento não prejudicará a validade e eficácia das
      demais cláusulas. Caso seja decretada a nulidade, anulabilidade ou ineficácia de qualquer das cláusulas deste
      instrumento, o Multimarcas.online tomará todas as providências, inclusive por meio da alteração deste instrumento,
      para que, em conformidade com a legislação em vigor, seja alcançado, na maior extensão possível, o resultado
      prático a que visava este instrumento com a(s) cláusula(s) inquinada(s). <br /><br />

      12.6. Títulos. Os títulos das cláusulas ou capítulos desta Política de Privacidade são meramente ilustrativos, e
      foram inseridos para facilitar a compreensão dos Usuários e dos Parceiros. <br /><br />

      12.7. Legislação aplicável. Os Usuários e os Parceiros declaram-se cientes e concordam que, independentemente do
      local de onde estejam utilizando a Plataforma, esta Política de Privacidade é regida pelas leis brasileiras.
      <br /><br />

      12.8. Foro. Em caso de disputas ou desentendimentos a respeito desta Política de Privacidade, fica eleito o Foro
      da Comarca de Caxias do Sul, Estado do Rio Grande do Sul, para dirimir quaisquer dúvidas ou controvérsias, com a
      exclusão de qualquer outro, por mais privilegiado que seja ou venha a ser.
    </p>

    <br />

    <p class="va-text-justify">Data da última atualização: 01/11/2023</p>

    <br />

    <va-button @click="downloadPdf">Baixar PDF</va-button>
  </va-modal>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'

const props = defineProps({
  showModal: {
    type: Boolean,
    required: true,
  },
})

const emits = defineEmits(['update:showModal', 'cancel', 'confirm'])

const internalShowModal = ref(props.showModal)

watch(
  () => props.showModal,
  (newVal) => {
    internalShowModal.value = newVal
  },
)

watch(
  () => internalShowModal.value,
  (newVal) => {
    emits('update:showModal', newVal)
  },
)

const onConfirm = () => {
  emits('confirm')
}

const onCancel = () => {
  emits('cancel')
}

const downloadPdf = () => {
  const link = document.createElement('a')
  link.href = '/termo.pdf'
  link.setAttribute('download', 'termo.pdf')
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
</script>
